// extracted by mini-css-extract-plugin
module.exports = {"bb-sidebar-toc":"bb-sidebar-toc__KphfX","active":"active__GPV5I","bb-sidebar-toc-hidden":"bb-sidebar-toc-hidden__i_9uR"};